import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-about">
          <h2>Moshiqe</h2>
          <p>
            A peaceful place for worship, learning, and community engagement.
          </p>
        </div>

        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>Home</li>
            <li>Prayer Times</li>
            <li>Gallery</li>
            <li>Contact</li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>Contact</h3>
          <p>📍 123 Mosque Street, City, Country</p>
          <p>📞 +123 456 7890</p>
          <p>✉️ info@moshiqe.com</p>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; 2025 Moshiqe. All Rights Reserved.
      </div>
    </footer>
  );
}
